const img = (filename) => `/uploads/images/guide/${filename}`

export const GUIDE_SHRIMP_PAGES = [
  {
    slug: 'first-meet',
    title: '接虾回家——认识你的龙虾 AI',
    lead: '刚把龙虾 AI 接回家，别急着喂复杂任务。先花 3 分钟互相认识一下，后面喂养才顺手。',
    steps: [
      {
        image: img('dclaw_1_1.png'),
        text: '双击打开龙虾 AI 客户端，用手机号登录。登录成功，就相当于给你的虾登记了“户口”。'
      },
      {
        image: img('dclaw_1_2.png'),
        text: '熟悉三个关键位置：中间的对话区是“虾窝”，输入框是“喂食口”，侧边栏是“工具箱”。以后每天都要和它们打交道。'
      },
      {
        image: img('dclaw_1_3.png'),
        text: '在输入框里打个招呼或问一个简单问题，比如“你好，介绍一下你自己”。第一次互动，从轻松开始。'
      },
      {
        image: null,
        text: '收到回复就说明你的虾“活”了，可以开始正式喂养。如果没反应，检查网络后重启客户端再试一次。'
      }
    ]
  },
  {
    slug: 'daily-feed',
    title: '每天喂虾——把日常任务交给它',
    lead: '虾养得好不好，全看每天喂什么。把写邮件、做表格、搜资料这类“饲料”交给它，你会越来越省心。',
    steps: [
      {
        image: img('dclaw_2_1.png'),
        text: '先喂它最熟悉的东西：写邮件、写文案、写通知。告诉它“帮我把这段话改得更正式一点”，它会立刻给出一版。'
      },
      {
        image: null,
        text: '记住提问三要素：背景 + 要求 + 格式。例如“我是运营（背景），写一条中秋促销短信（要求），80 字以内、口语化（格式）”。说得越清楚，喂得越准。'
      },
      {
        image: img('dclaw_2_2.png'),
        text: '它的回答不是一次定稿。像教它做事一样多轮追问，直到满意为止。'
      },
      {
        image: img('dclaw_2_3.png'),
        text: '有文档、表格或图片，直接上传。让它“基于这份合同帮我总结重点”，它就能对着你的材料干活，而不是凭空发挥。'
      }
    ]
  },
  {
    slug: 'skill-up',
    title: '养熟你的虾——让它越来越懂你',
    lead: '养熟的表现：你刚说上半句，它就懂下半句。技能插件和固定习惯，是养熟的关键。',
    steps: [
      {
        image: img('dclaw_3_1.png'),
        text: '如图所示调用技能：打开技能列表——文档分析、数据处理、图片生成……每一招都是虾的“必杀技”，选一个它就会切换成专业模式帮你干活。'
      },
      {
        image: img('dclaw_3_2.png'),
        text: '挑一个用得上的技能（比如“文档分析”），按提示上传内容。它会从“聊天搭子”变成“专业帮手”。'
      },
      {
        image: null,
        text: '同样的事情用同样的说法问它，几次之后输出的格式、语气会越来越贴合你的习惯。养虾的乐趣就在这种“默契”。'
      },
      {
        image: img('dclaw_3_3.png'),
        text: '让它露一手：生成一个视频、做一页 PPT 或搭一个网站。看到成品的那一刻，你会觉得这只虾没白养。'
      }
    ]
  },
  {
    slug: 'advanced',
    title: '进阶养虾——解锁能力与健康检查',
    lead: '虾偶尔也会“闹脾气”：能力找不到、回答不满意。这一页教你进阶玩法，也教你怎么给它做“健康检查”。',
    steps: [
      {
        image: img('dclaw_4_1.png'),
        text: '逛一逛技能中心：全部可用技能都在这里，按需浏览挑选。新技能会不定期上架，偶尔回来逛逛总有惊喜。'
      },
      {
        image: img('dclaw_4_2.png'),
        text: '回答不满意时试试切换模型：不同模型各有所长，就像换一种配方喂虾。哪个顺手用哪个。'
      },
      {
        image: img('dclaw_4_3.png'),
        text: '虾也需要“健康检查”：遇到问题或想提建议，点击左下角反馈按钮告诉团队。你的反馈就是虾的下一次进化方向。'
      }
    ]
  }
]

export function getShrimpPage(slug) {
  return GUIDE_SHRIMP_PAGES.find((p) => p.slug === slug) || null
}
